var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('h2',{staticClass:"rounded-numbered-item"},[(_vm.$slots.number)?_c('div',{staticClass:"rni--number"},[_vm._t("number")],2):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }